import styled from "styled-components";

import content from "../content/password-activation";
import coverPng from "../images/cover.png";
import { colors, device, paddingSmall } from "../variables";

const PasswordActivation = ({ language }) => {
  document.title = "Chess Universe | Password Activation";

  return (
    <PasswordActivationWrapper>
      <BackgroundImage src={coverPng}></BackgroundImage>
      <Wrapper>
        <ContentWrapper>
          <Element>{content[0][language]}</Element>
          <Element>{content[1][language]}</Element>
        </ContentWrapper>
      </Wrapper>
    </PasswordActivationWrapper>
  );
};

const PasswordActivationWrapper = styled.div`
  max-height: 1000px;
  height: calc(100vh - 200px);
`;

const BackgroundImage = styled.img`
  position: relative;
  top: -2px;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
`;

const Wrapper = styled.div`
  position: absolute;
  height: calc(100vh - 200px);
  top: 100px;
  left: 0;
  z-index: 3;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ContentWrapper = styled.div`
  padding: 100px ${paddingSmall};
  background-color: ${colors.black};
  text-align: center;
  width: 100%;
  @media ${device.laptop} {
    padding: 100px 0;
  }
`;

const Element = styled.div`
  font-family: "Rockwell", sans-serif;

  &:first-child {
    margin-bottom: ${paddingSmall};
    text-transform: uppercase;
  }

  &:not(:first-child) {
    color: ${colors.yellow};
  }
`;

export default PasswordActivation;
